import { render } from "./ShopSubProductsTable.vue?vue&type=template&id=042eb2e1"
import script from "./ShopSubProductsTable.vue?vue&type=script&lang=js"
export * from "./ShopSubProductsTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__